import moment from 'moment'
import { PatientIdentityStatusEnum } from '../../_props'
import { PatientIDentityStatusColorHex, PatientIDentityStatusColorName } from '../_props'

export const IdentityAttributes = [
    {
        label: 'Identité homonyme',
        code: 1,
    },
    {
        label: 'Identité douteuse',
        code: 2,
    },
    {
        label: 'Identité fictive',
        code: 3,
    },
]

export const PatientIDentityStatusColors: Record<PatientIDentityStatusColorName, PatientIDentityStatusColorHex> = {
    red: '#F95F62',
    blue: '#4B91F6',
    orange: '#FF8C00',
    green: '#52CB94',
}

export const getBackgroundColor = (status: PatientIdentityStatusEnum): PatientIDentityStatusColorHex | undefined => {
    const { red, blue, orange, green } = PatientIDentityStatusColors

    if (status === 'PROVISIONAL') return red
    if (status === 'VALIDATED') return blue
    if (status === 'RECOVERED') return orange
    if (status === 'QUALIFIED') return green
    return undefined
}

export const humanizePatientIdentityStatus = (status: PatientIdentityStatusEnum) => {
    const translations: Record<PatientIdentityStatusEnum, string> = {
        PROVISIONAL: 'Provisoire',
        VALIDATED: 'Validée',
        RECOVERED: 'Récupérée',
        QUALIFIED: 'Qualifiée',
    }

    return translations[status]
}

export const availablePatientIdentityStatusCodes = [1, 2, 3, 4]

export const patientIdentityStatusCodesMap: Record<number, PatientIdentityStatusEnum> = {
    1: 'PROVISIONAL',
    2: 'RECOVERED',
    3: 'VALIDATED',
    4: 'QUALIFIED',
}

export const patientIdentityStatusSlugsMap: Record<PatientIdentityStatusEnum, number> = {
    PROVISIONAL: 1,
    RECOVERED: 2,
    VALIDATED: 3,
    QUALIFIED: 4,
}

export const getIdentityStatusSlug = (code: number | undefined) => {
    if (code && availablePatientIdentityStatusCodes.includes(code)) return patientIdentityStatusCodesMap[code]
    return undefined
}

export const shouldDirty = { shouldDirty: true }

export const handleDate = (date: string | undefined) => {
    if (!date) {
        return new Error('Donnée manquante')
    }
    const momentDate = moment(date)
    const isValidDate = momentDate.isValid()
    return isValidDate ? String(momentDate.format('DD/MM/YYYY')) : new Error('Donnée invalide')
}
